<div class="app-code-editor">
  <div #editor></div>
</div>
